import React, {  useState,useRef, useEffect } from 'react';
import axios from 'axios';
import Modal from './Modal';
//import Locations from './CVLocations';
import { getUserId,aPIURL,auTHURL,pdfUrl} from '../utils/common';
import ReactPaginate from "react-paginate";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import LoadingSpinner from "./LoadingSpinner";
import { useReactToPrint } from 'react-to-print';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import Enumerate from "linq";


const VehicleHistory = () => 
{
    const fileType ="xlsx";
    const [tripNo,setTripNo]=useState("");
    const [showEditDriver, setShowEditDriver] = useState(false); 
    const [sdate,setSdate]=useState();
    const [edate,setEdate]=useState();
    const[arrayvehicle,setArrayvehicle]=useState([]);
    const [items,setItems]= useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const tableRef = useRef(null);
    const API_URL=aPIURL();
    const AUTH_URL= auTHURL();
    const PDF_Url=pdfUrl();
    const [userId, setUserId]  = useState({});
    const [custID, setCustID]  = useState('0');
    const [dIMEINo, setDIMEINo]  = useState('0'); 
    const [devName, setDevName]  = useState(""); 
    const [dID, setDID]  = useState('0');
    const [vCategoryID, setVCategoryID]  = useState('0');
    
    const [post, setPost] = useState([]);
    const [temppost, setTempPost] = useState([]);
    const [searchpost, setSearchempPost] = useState([]);
    const [deviceData , setDeviceData]  =useState([]);
    const [filteredDevicedata,setFilteredDevicedata ]  =useState([]);
    const [vCategoryData,setVCategoryData ]  =useState([]);
    const [showDetails,setShowDetails ]  = useState(false);
    const [showLocation,setShowLocation ]  = useState(false);    
    const [showEditVehicle,setShowEditVehicle ]  = useState(false);    
    const [order, setOrder] = useState("ASC");
    const [number, setNumber] = useState(1); 
    const [postPerPage] = useState(10);
    const AccountID =getUserId(); 
    const [imeiNumber,setImeiNumber]=useState("");
    const [statusId, setStatusId]= useState(0);
    const [vehicleNo,setVehicleNo]=useState("");
    

  const sorting=(col)=>
  {

    try
    {
      if(order==="ASC")
      {
              const sorted=[...post].sort((a,b)=>
              a[col].toLowerCase() > b[col].toLowerCase() ? 1: -1
              );
              setPost(sorted);
              setOrder("DSC");
      }
      if(order==="DSC")
      {
              const sorted=[...post].sort((a,b)=>
              a[col].toLowerCase() < b[col].toLowerCase() ? 1: -1
              );
              setPost(sorted);
              setOrder("ASC");
      }
    }
    catch(error) 
    {
      console.log(error.message);
    }  
            
  }


  useEffect(() => 
  {  
          FillVehicle();    
    
   }, []);
  
  const lastPost = number * postPerPage;
  const firstPost = lastPost - postPerPage;
  const currentPost = post.slice(firstPost, lastPost);
  let PageCount = Math.ceil(post.length / postPerPage);

 const FillVehicle=()=>
 {
  
  const user_id = getUserId();
  const curls=API_URL+`VehicleList/?AccountID=0&TypeID=1`;
  setArrayvehicle([]);
  //alert(curls);
  axios.get(curls).then(response => 
    {                            
      setArrayvehicle(response.data.data)
     
   }).catch(function(error)
   {
      console.log(error.message);
  });
      
 }
 const FillReportType=()=>
  {
   
   const user_id = getUserId();   
   const curls=API_URL+`VehicleList/?AccountID=${user_id}&TypeID=1`;
   setArrayvehicle([]);
   alert(curls);
   axios.get(curls).then(response => 
     {                            
       setArrayvehicle(response.data.data)
      
    }).catch(function(error){
   
     console.log(error.message);});
       
  }
const FillGrid=(Type_ID)=>
{
   
    setIsLoading(true);
    const url=API_URL+`GetGPSHistory/?FromDate=01-01-2020&ToDate=04-04-2030&IEMI=${imeiNumber}`;
    setPost([]); 
 
    axios.post(url).then(response => 
      {  
          setIsLoading(false);
          console.log("--------------------------------------------------------response.data.data--------------------------------------------------------"); 
          console.log(response.data.data);        
          setPost(response.data.data);            

      }).catch(function(error) 
      {
            setIsLoading(false);
            console.log(error.message);
      
      });
}  
const SearchFillGrid=(IMEI)=>
  {
    setIsLoading(true);
    
      // 30 day pic data from stored procedure 
      //const url="";//API_URL+`GetGPSHistory/?AccountID=${AccountID}&TypeID=${Type_ID}`;         
      const url=API_URL+`GetGPSHistory/?FromDate=01-01-2020&ToDate=04-04-2030&IEMI=${IMEI}`;
      //alert(url);
      setPost([]); 
      setTempPost([]);
      axios.post(url).then(response => 
        {  
            setIsLoading(false);
            console.log(response.data.data);        
            setPost(response.data.data)   
            setTempPost(response.data.data);
        }).catch(function(error) 
        {
              setIsLoading(false);
              console.log(error.message);
        
        });
  } 

const ChangePage = ({ selected }) => {
        
        setNumber(selected+1);
  };
       

const showDetailsModal = (index) => 
{
        const d_Id = index;
                               
        const urls=API_URL+`GetDeviceDetails/${d_Id}/`;    
      
        axios.post(urls).then(response =>
             {                  
                setFilteredDevicedata(response.data.data);
             }).catch(function(error) {  console.log(error.message); });
            
             setShowDetails(true);  
             setShowEditDriver(false);
             setShowEditVehicle(false);   
             setShowLocation(false);   
}

const showLocationDetailsModal = (index) => {
    const d_Id = index;                           
    const urls=API_URL+`GetDeviceDetails/${d_Id}/`;
    axios.post(urls).then(response => {                  
      setFilteredDevicedata(response.data.data);
    }).catch(function(error) {  console.log(error.message); });

    setDID(d_Id);  
    setShowDetails(true);  
    setShowEditDriver(false);
    setShowEditVehicle(false);   
    setShowLocation(true);       
}
const closeModal = () => 
{
        setShowDetails(false);
        setShowLocation(false); 
        setShowEditDriver(false);
        setShowEditVehicle(false);       
}
//AutoSerach Drop Down

const AutoSearch=(TypeID)=>
{
    setItems([]);
    const daurls=API_URL+`AutoSearchVList/${AccountID}/${TypeID}`; 
    //alert(daurls);
    const response =  axios.get(daurls).then(response => 
      {       
            setItems(response.data.items);
            console.log(items); 

      }).catch(function(error) 
       {
            console.log(error.message);

      });      
}
  
const changeVehicle = (e) => 
{   
    setTripNo(e.target.value)
} 
const SDatechangeHandler = (e) => 
{   
    setSdate(e.target.value)
} 
const EDatechangeHandler = (e) => 
{   
     setEdate(e.target.value)
}
const ResetTripList=()=>
{
    setSdate("");
    setEdate("");
    setTripNo("");  

}
const FilterGrid =() => 
{
    
        if(tripNo ==="" || tripNo ===0)
        {
            toast.error("Vehicle number is required.");
           return;
        }   
        else if(sdate > edate)
        {
              toast.error("From date should be less than to date.");
              return;
        }
        else
        {
          setIsLoading(true);
          const Account_ID = getUserId(); 
          const searchparams = JSON.stringify({
             "accountID": Account_ID,
             "vehicleNumber":tripNo,
             "fromDate":sdate,
             "endDate": edate,
             "orderBy": ""
            });
  
    setPost([])
    axios.post(API_URL+'ReportforDistance/', searchparams,
    {  
        "headers":{"content-type": "application/json",},})

    .then(function (response) 
    {    
         console.log(response.data.data);
          setPost(response.data.data);   
          setIsLoading(false);                    
          
    })
    .catch(function (error) 
    {
           setIsLoading(false);
           toast.info("No data found !");
    });
    }
    }
const handleOnSearch = (string, results) => 
{ 
// onSearch will have as the first callback parameter
// the string searched and for the second the results.
console.log(string, results)
}

const handleOnHover = (result) =>
   {
// the item hovered

//SetVeicleNo(items.id);

//console.log(items.imeiNumber)
}
const handleOnSelect = (items) => 
{
  // the item selected
  console.log(items);
  //alert(items.id);
  //alert(items.name);
  setVehicleNo(items.name);
  setImeiNumber(items.imeiNumber);
  SearchFillGrid(items.imeiNumber);
  
}
  const handleOnFocus = () => 
    {  

    console.log('Focused')
    }

    const formatResult = (items) => {
      return (
      <>
      
        <span style={{ display: 'none', textAlign: 'left' }}>{items.id}</span>
        <span style={{ display: 'block', textAlign: 'left' }}>{items.name}</span>
      </>
      )
      }
//End Auto Serch Drop down


const exportStatus = e => {
 
  const value = e.target.value; 
  setStatusId(e.target.value);
  FillGrid(value);
}
const exportToCSV=()=>
  {
    const newPost = post.map(({ end_Latitude,end_Longitude,haltAddress,haltFromPreviousTrip,start_Latitude,start_Longitude,sno, ...rest }) => rest);
     const ws= XLSX.utils.json_to_sheet(newPost);        
     var wscols = [
        {wch:20} ,
        {wch:20} ,
        {wch:20},
        {wch:20},
        {wch:20},
        {wch:20},
        {wch:60},         
        {wch:60}       
    ];
 
    var wsrows = [
       {hpx: 30}
    ];
    
    ws['!cols'] = wscols;
    ws['!rows']=wsrows;
         
    let Heading = [['Vehicle No.','Stop No.','Start Date','End Date','Distance in Km.','Average Speed in Km/h','Start Location','End Location']];
    const wb={Sheets:{TripHistory:ws},SheetNames:["TripHistory"]};
    XLSX.utils.sheet_add_aoa(ws, Heading);     
    const excelBuffer= XLSX.write(wb,{bookType:"xlsx",type:"array"});
    const data= new Blob([excelBuffer],{type:fileType});
    FileSaver.saveAs(data,"AvtTripHistoryReport"+".xlsx");   

}
const exportDownload = e => 
{  
  
  const value = e.target.value; 
  //alert(value)

  if(value=="Excel")
  {
      exportToCSV();    
  }
  if(value=="PDF")
  {
       // handlePrint(null, () => tableRef.current);
       onPDFLoad();
  }
}
const onPDFLoad = () =>
  {
    //process.env.REACT_APP_REPORT;    
     var rptURL=PDF_Url + "Avtdisreport.pdf"
     //alert(rptURL);
     window.open(rptURL);
  };
/*const { onDownload } = useDownloadExcel({
  currentTableRef: tableRef.current,
  filename: "Trip History Details",
  sheet: "TripHistory"
});*/
const handlePrint = useReactToPrint({
  documentTitle: "History Details",
  onBeforePrint: () => console.log("before printing..."),
  onAfterPrint: () => console.log("after printing..."),
  removeAfterPrint: true,
});
const styles = {
headsection: {
    backgroundColor:"black", color:"white",textAlign:"center"
},
tcaption: {
    textAlign:"left",fontWeight:"bold","vertical-align": "middle",width:"15%"
}
}
if (isLoading) 
  {
    return <center>< LoadingSpinner/></center> ;
  }
return (
    <>
      <Modal isOpen={showDetails} >            
            <div  class="modal-header">
            <h5 className='modal-title'>Device Details</h5>
            <button type="button" class="btn-close" onClick={closeModal}></button>
            </div>
            <div class="modal-body">                      
            <div class="row">
            <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px" }}><b>Device Details </b> </span> 
            <table >
            {filteredDevicedata.map(devdata1 => (
            <tr key={devdata1.id}>
                <td>                    
                <div class="row">             
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Name : </b>        
                {devdata1.deviceName}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Model : </b>       
                {devdata1.model}
                </div>
                <div class="col-sm-6 col-md-4 form-group"> &nbsp;
                <b> IMEI Number : </b>      
                {devdata1.iemiNumber}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Mobile Number : </b>       
                {devdata1.mobileNumber}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Group : </b>        
                {devdata1.groupName}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Time-Zone : </b>      
                {devdata1.timeZone}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Activation Date : </b>        
                {devdata1.activationDate}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Expiration Date : </b>       
                {devdata1.expirationDate}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Status : </b>        
               {devdata1.status}                   
                </div>                    
                </div>               
                </td>                            
            </tr>
             ))}
            </table>
            
            <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px"}}><b>Driver Details </b> </span> 
            <table >
            {filteredDevicedata.map(devdata1 => (
                
            <tr key={devdata1.id}>
                <td>                    
                <div class="row">                
               
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Driver Number : </b>      
                {devdata1.driverName}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Father Name : </b>       
                {devdata1.fatherName}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Contact Number : </b>        
                {devdata1.contactNumber}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> License Number : </b>       
                {devdata1.licenceNumber}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> License From : </b>        
                {devdata1.licenceIssueFrom}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> License Validity : </b>      
                {devdata1.licenceValidity}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Address : </b>        
                {devdata1.address}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Identity Number : </b>       
                {devdata1.identityNumber}
                </div>
               
                </div>
                
                
                </td>                            
            </tr>
             ) )
            }
            </table>
            
            <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px" }}><b>Vehicle Details </b> </span> 
            <table >
            {filteredDevicedata.map(devdata1 => (
            <tr key={devdata1.id}>
                <td>                    
                <div class="row">
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Vehicle Number : </b>      
                {devdata1.vehicleNumber}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> VIN : </b>       
                {devdata1.vin}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Engine Number : </b>        
                {devdata1.enginNumber}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Vehicle Brand : </b>       
                {devdata1.vehicleBrand}
                </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                <b> Vehicle Model : </b>        
                {devdata1.vehicleModel}
                </div>
               
                </div>
                </td>                            
            </tr>
             )             
            )
            }
            </table>
            </div>
            </div>
           
      </Modal>
      <Modal isOpen={showLocation} >
            <div class="modal-header">
                <h5 className='modal-title'>Device Location Details</h5>
                <button type="button" class="btn-close" onClick={closeModal}></button>
                </div>
                <div class="modal-body">
            
            <div class="row">
           
           {/*} <Locations device_Id={dID}/> {*/}
            </div> </div>
      </Modal>       
          
      <div className="top-bar clearfix">
        <div className="row justify-content-between">
          <div class="col-12 col-lg-5 d-flex align-item-center">
            <h2 className="m-0"> History</h2>            
        {/*<ReactSearchAutocomplete placeholder="Vehicle Number" items={items} onSearch={handleOnSearch} onHover={handleOnHover} onSelect={handleOnSelect} onFocus={handleOnFocus}    autoFocus formatResult={formatResult} />*/}
        {/* Search field*/}
              
     </div>
     <div class="col-12 col-lg-7 d-flex justify-content-end">    
                  
            <select onChange={exportStatus} className="form-control" name="DStatus"   style={{ "backgroundColor":"white",width:"auto", "float": "right","margin-right": "5px","height": "15px"}}   value={statusId} >             
            <option value={"0"}>All</option>
            <option value={"1"}>Recent</option>                        
            </select>
            <select onChange={exportDownload}  className="form-control w-auto" name="DDownload" >
            <option value={"Download"}>Download</option>    
            <option value={"Excel"}>Excel</option>    
            <option value={"PDF"}>PDF</option>                     
            </select>
     </div>
     
     </div>
     </div>
     <div className="container-fluid p-3">

  <div class="card mb-3 shadow no-border border-0">
  <div class="card-body">
  <div class="row align-items-end">
  
    <div class="col-sm-3 col-lg-2">Vehicle# <span style={{color: "red"}}>&nbsp;*</span>
      <select className="form-control"  name="startAddress" value={tripNo} onChange={changeVehicle} >
       <option value={0}>Select Vehicle</option>
              {
                  arrayvehicle.map((e, key) => 
                  {
                         return <option key={key} value={e.vehicleNumber}>{e.vehicleNumber}</option>;
                  })
               }
       </select>
     </div>     
      <div class="col-sm-3 col-lg-2">Start Date
      <input class="form-control" aria-label="SDate" onChange={SDatechangeHandler} value={sdate} type="date" />
      </div> 
      <div class="col-sm-3 col-lg-2">End Date
      <input class="form-control" aria-label="EDate" onChange={EDatechangeHandler} value={edate}  type="date" />
      </div>    
      <div class="col-sm-4 col-lg-2">
      <button type="button" class="btn btn-primary2 mt-20" tabindex="6" id="btnTripAdvancedSearchNew" onClick={FilterGrid} >Search</button>
      <button type="button" class="btn btn-secondary mt-20" id="btnTripResetAdvancedSearchNew" tabindex="7" onClick={ResetTripList}>Reset
      </button></div>
      </div>    
  </div>
</div>

<div class="card mb-3 shadow no-border border-0">
<div class="card-body p-0">
<table ref={tableRef} class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
        <thead>
            <tr>
                {<th width="7%" style={{textAlign:"center","cursor": "pointer"}}>Stop No. </th>}
                <th width="9%"  style={{textAlign:"center","cursor": "pointer"}}>Vehicle No. </th>                
                <th width="10%" onClick={()=>sorting("tripStartDateTime") } style={{textAlign:"center","cursor": "pointer"}}> Start Date &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="10%" onClick={()=>sorting("tripEndDateTime") } style={{textAlign:"center","cursor": "pointer"}}> End Date &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="10%" onClick={()=>sorting("distance") } style={{textAlign:"center","cursor": "pointer"}}>Distance &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="10%" onClick={()=>sorting("averageSpeed") } style={{textAlign:"center","cursor": "pointer"}}>Average Speed &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="23%" onClick={()=>sorting("startAddress") } style={{textAlign:"center","cursor": "pointer"}}>Start Location &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="23%" onClick={()=>sorting("endAddress") } style={{textAlign:"center","cursor": "pointer"}}>End Location &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                {/*GT-195
                <th width="15%" onClick={()=>sorting("status") } style={{textAlign:"center","cursor": "pointer"}}>Status &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="5%"  onClick={()=>sorting("id") }  style={{textAlign:"center","cursor": "pointer"}}>#</th>*/}
            </tr>
        </thead>
        <tbody>
        {currentPost.map((devdata) => 
        {
        return (
            <>                             
            <tr key={devdata.tripno}>              
              <td style={{textAlign:"center"}}>{devdata.tripno}</td>       
              <td style={{textAlign:"center"}}>{devdata.vehicleNumber}</td>                     
              <td style={{textAlign:"center"}}>{devdata.tripStartDateTime}</td>             
              <td style={{textAlign:"center"}}>{devdata.tripEndDateTime}</td>              
              <td style={{textAlign:"center"}}>{devdata.distance} km</td>
              <td style={{textAlign:"center"}}>{devdata.averageSpeed} km/hr</td>
              <td >{devdata.startAddress}</td>
              <td >{devdata.endAddress}</td>
            </tr>
              </>
                );
          })}
          </tbody>
        </table>

        <ReactPaginate  previousLabel={"<<"}  nextLabel={">>"}   pageCount={PageCount}  onPageChange={ChangePage}     
            disableInitialCallback={true}  initialPage={0}  containerClassName={'pagination justify-content-end'}
            pageClassName={'page-item'}   pageLinkClassName={'page-link'}  previousClassName={'page-item'}
            previousLinkClassName={'page-link'}  nextClassName={'page-item'}  nextLinkClassName={'page-link'}
            breakClassName={'page-item'}  breakLinkClassName={'page-link'}  activeClassName={'active'}></ReactPaginate>
</div>
</div>  </div>
            <ToastContainer position="bottom-right" autoClose={4000} theme="light"/>              
        </>
    );}

export default VehicleHistory;
